import { render, staticRenderFns } from "./TariffFilter.vue?vue&type=template&id=b446a07c&"
import script from "./TariffFilter.vue?vue&type=script&lang=ts&"
export * from "./TariffFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports